import { render, staticRenderFns } from "./Slots.vue?vue&type=template&id=03d66995&"
import script from "./Slots.vue?vue&type=script&lang=js&"
export * from "./Slots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports